export const SUPER_ADMIN = {
  SUPER_ADMIN_PAGE_TITLE: 'Admin Tools',
  SUPER_ADMIN_NAV_ITEM_ICON_ALT: 'Admin Page',
  SUPER_ADMIN_NAV_LABEL: 'Admin Tools',
  SUPER_ADMIN_PAGE_TABS_ORGS: 'Organizations',
  SUPER_ADMIN_PAGE_TABS_FEATURE_FLAGS: 'Feature Flags',
  CURRENTLY_VIEWING_LABEL: 'Currently Viewing',
  TRIGGER_CLASSY_IMPORT_CAMPAIGNS: 'Import Classy Campaigns',
  TRIGGER_CLASSY_IMPORT_CONSTITUENTS: 'Import Classy Constituents',
  TRIGGER_CLASSY_IMPORT_CONTRIBUTIONS: 'Import Classy Contributions',
  TRIGGER_CLASSY_IMPORT_SUCCESS: '{type} import triggered successfully',
  TRIGGER_CLASSY_IMPORT_FAILURE:
    'There was a problem triggering an import for {type}. Please try again.',
  PRODUCTION: 'Production',
  STAGING: 'Staging',
  DEVELOPMENT: 'Development',
};

export const ORG_MANAGEMENT = {
  ORG_MGMT_TABLE_HEADER_NAME: 'Name',
  ORG_MGMT_TABLE_HEADER_CREATED: 'Created',
  ORG_MGMT_TABLE_HEADER_ADMIN: 'Administrator',
  ORG_MGMT_SHOW_MORE: 'Show More',
  ORG_MGMT_SEARCH_LABEL: 'Find Organization (by name or ID)',
  ORG_MGMT_CREATE_ORG_CTA: 'Create Organization',
  ORG_MGMT_DEMO_ORG: 'Demo Org',
  ORG_MGMT_CREATE_ORG_DIALOG_TITLE: 'Create Organization',
  ORG_MGMT_CREATE_ORG_DIALOG_NAME: 'Organization Name',
  ORG_MGMT_CREATE_ORG_DIALOG_EIN: 'Employer ID Number',
  ORG_MGMT_CREATE_ORG_DIALOG_PHONE: 'Org Phone Number',
  ORG_MGMT_CREATE_ORG_DIALOG_USE_EIN: 'Use EIN',
  ORG_MGMT_CREATE_ORG_SUCCESS: 'Your new organization has been created',
  ORG_MGMT_CREATE_ORG_ERROR:
    'There was a problem creating your new organization. Please try again.',
  ORG_MGMT_FETCH_ORGS_ERROR:
    'There was a problem with fetching the organizations. This might be related to you not having sufficient permissions to access this info.',
  ORG_MGMT_CREATE_ORG_ERROR_ALREADY_EXISTS:
    'An org already exists with the EIN or phone number provided. Please try again.',
  ORG_MGMT_UPDATE_ORG_ERROR:
    'There was a problem updating {orgName}. Please try again',
  ORG_MGMT_UPDATE_ORG_SUCCESS: '{orgName} has been successfully updated',
};

export const FEATURE_FLAGS = {
  FEATURE_FLAGS_DESCRIPTION:
    'Feature Flags are used to turn on and off development features.',
  FEATURE_FLAGS_DETAILS: 'Details available here.',
  FEATURE_FLAGS_CREATE: 'Create Feature Flag',
  FEATURE_FLAGS_DELETE: 'Delete Feature Flag',
  FEATURE_FLAGS_DISABLE: 'Disable Feature Flag',
  FEATURE_FLAGS_ENABLE: 'Approved Organizations',
  FEATURE_FLAGS_TABLE_HEADER_NAME: 'Name',
  FEATURE_FLAGS_TABLE_HEADER_STATUS: 'Status',
  FEATURE_FLAGS_CREATE_NAME: 'Feature Flag Name',
  FEATURE_FLAGS_CREATE_HELPER_TEXT:
    'Must consist of letters, numbers, and no spaces.',
  FEATURE_FLAGS_DELETE_TEXT:
    'Are you sure you want to delete the <b>{flagName}</b> feature flag? Access will be removed for any approved organizations.',
  FEATURE_FLAGS_GENERIC_ERROR_MESSAGE:
    'There was a problem {msg}. Please try again.',
  FEATURE_FLAGS_NO_FLAGS: "Looks like you haven't added any feature flags yet.",
  FEATURE_FLAGS_ERR_MSG_GET: 'fetching feature flags',
  FEATURE_FLAGS_ERR_MSG_DEL: 'deleting your feature flag',
  FEATURE_FLAGS_ERR_MSG_UPD: 'updating your feature flag',
  FEATURE_FLAGS_DISABLE_TEXT_1: 'Are you sure you want to disable the ',
  FEATURE_FLAGS_DISABLE_TEXT_2:
    'feature flag? Once switched off, this feature will no longer be available to all approved organizations.',
  FEATURE_FLAGS_ENABLE_FLAG_LABEL: 'Flag',
  FEATURE_FLAGS_ENABLE_ALL: 'Enable for ALL Organizations',
  FEATURE_FLAGS_ENABLE_LIST: 'Enable for specific list of Organizations',
  FEATURE_FLAGS_VIEW_EDIT_LIST: 'View/Edit List',
  FEATURE_FLAGS_ALERT_SUCCESS_NEW: 'Your new feature flag has been created.',
  FEATURE_FLAGS_ALERT_SUCCESS_EDIT: 'Your feature flag has been updated.',
  FEATURE_FLAGS_ALERT_SUCCESS_DELETE: 'Your feature flag was deleted.',
  FEATURE_FLAGS_ALERT_ERROR_NEW:
    'There was a problem creating your new feature flag. Please try again.',
  FEATURE_FLAGS_ALERT_ERROR_EDIT:
    'There was a problem updating your feature flag. Please try again.',
  FEATURE_FLAGS_ALERT_ERROR_DELETE:
    'There was a problem deleting your feature flag. Please try again.',
  FEATURE_FLAGS_SEARCH_ORGS: 'Search Organizations',
  FEATURE_FLAGS_NO_ORGS:
    'No organziations have been given access to this feature yet.',
  FEATURE_FLAG_NOT_EXIST:
    'The feature flag {flagName} does not exist in this environment.',
  FEATURE_FLAG_CREATE_IT: 'CREATE IT',
  FEATURE_FLAG_UNUSED: 'Looks like this flag is no longer being used.',
};

export const BULK_IMPORT = {
  IMPORT_DATA: 'Import Data',
  VIEW_IMPORT_DATA: 'View Import Report',
  UPLOAD_CSV_TEMPLATES: 'Upload CSV templates',
  IMPERSONATE: 'Impersonate User',
  IMPERSONATE_ROLESET: 'User type to impersonate',
  IMPORT_PROCESSED: 'Your import is being processed',
  IMPORT_PROCESSEED_BODY_1:
    'You will recieve an email when the import is finished.',
  IMPORT_PROCESSEED_BODY_2:
    'Please note that you will not be able to begin another import while this one is being processed.',
  IMPORT_IN_PROGRESS: 'Import already in progress',
  IMPORT_IN_PROGRESS_BODY:
    'Another upload is being processed. The person who initiated the import will receive an email when it has been complete.',
  IMPORT_REPORT: 'Import Report - {orgName}',
  IMPORT_REPORT_WARNING:
    'Note: You will not have access to this report after the next import',
  IMPORT_MORE_DATA: 'Import More Data',
  IMPORT_FIX_ERRORS: 'Fix errors on .csv and reupload',
  IMPORT_NO_REPORT:
    'Data has not been uploaded yet. Click the button below to import data.',
  IMPORT_SUCCESS: '{count} Successes',
  IMPORT_ERRORS: '{count} Errors',
  IMPORT_SKIPPED: '{count} Skipped',
  IMPORT_ERROR_LIST: 'Import Error List',
  IMPORT_CATEGORY: 'Category',
  IMPORT_COLUMN: 'Column',
  IMPORT_ROW: 'Row',
  IMPORT_REASON: 'Error Reason',
  IMPORT_VALUE: 'Value',
  IMPORT_ERROR_MESSAGE:
    'The import for {category} failed due to: {reason}. Please review the .csv and try again.',
  IMPORT_FAILED: 'Import Failed',
};
